import React, { useState } from "react";
import CLientVendorsPageTable from "./Table";
import { useForm } from "../../../../hooks/formHook";
import { Paper, Typography } from "@mui/material";
import { getCompanyVendors } from "./api";
import { cols } from "./utils";

const companyId = 1;

export default function CLientVendorsPage({ type }) {
  const { onChange, onSubmit, values, setValues } = useForm(
    updateVendorsCallback,
    []
  );

  React.useEffect(() => {
    const func = async () => {
      if (type === "customers") {
        const vendors = await getCompanyVendors("customer");
        setValues(vendors);
      } else {
        const vendors = await getCompanyVendors("vendor");
        setValues(vendors);
      }
    };
    func();
  }, [type]);

  async function updateVendorsCallback() {
    console.log("first");
  }

  return (
    <Paper sx={{ m: 2, pb: 4 }}>
      <Typography variant="h6" sx={{ m: 2 }}>
        Company {type === "vendors" ? "Vendors" : "Clients"} :
      </Typography>
      <div style={{ textAlign: "center" }}>
        <CLientVendorsPageTable
          rows={values}
          onChange={onChange}
          cols={cols}
          setVendorsArray={setValues}
          type={type}
        />
      </div>
    </Paper>
  );
}
